import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import CloseIcon from "material-ui-icons/Close";
import InfiniteCalendar, { Calendar, withRange } from "react-infinite-calendar";
import "react-infinite-calendar/styles.css";
import Dialog, { DialogActions } from "material-ui/Dialog";
import { blue } from "material-ui/colors";

const styles = theme => ({
  root: {},
  inner: {
    display: "flex",
    flexDirection: "column"
  },
  calendar: {
    flexGrow: 1
  },
  actions: {
    display: "flex",
    height: 32,
    justifyContent: "space-between"
  }
});

const CalendarWithRange = withRange(Calendar);

const DatePickerDialog = props => {
  const { range, setRange, visible, onSave, close, classes } = props;

  const handleSaveButton = () => {
    onSave(range);
    close();
  };

  return (
    <Dialog open={visible} onClose={close}>
      <div className={classes.inner}>
        <DialogActions className={classes.actions}>
          <IconButton onClick={close} color="primary">
            <CloseIcon />
          </IconButton>
          <Button onClick={handleSaveButton} color="primary">
            Save
          </Button>
        </DialogActions>

        <div className={classes.calendar}>
          <InfiniteCalendar
            theme={{
              selectionColor: blue["A700"],
              textColor: { default: "#333", active: "#FFF" },
              weekdayColor: blue[400],
              headerColor: blue[600],
              floatingNav: {
                background: blue[400],
                color: "#FFF",
                chevron: "#FFA726"
              }
            }}
            Component={CalendarWithRange}
            selected={range}
            locale={{
              headerFormat: "MMM Do"
            }}
            onSelect={setRange}
          />
        </div>
      </div>
    </Dialog>
  );
};
DatePickerDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  range: PropTypes.object.isRequired,
  setRange: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
export default withStyles(styles, { name: "DatePickerDialog" })(
  DatePickerDialog
);



// WEBPACK FOOTER //
// ./src/DatePickerDialog.js